import parsePhoneNumber, { AsYouType } from 'libphonenumber-js';

const DEFAULT_COUNTRY_CODE = 'US';

export const formatPhoneNumber = (
  phoneNumber,
  countryCode = DEFAULT_COUNTRY_CODE,
) => new AsYouType(countryCode).input(phoneNumber);

export const validatePhoneNumber = (
  number,
  countryCode = DEFAULT_COUNTRY_CODE,
) => {
  try {
    const phoneNumber = parsePhoneNumber(number, countryCode);

    return phoneNumber.isPossible();
  } catch {
    // We just want to suppress the error
  }

  return false;
};
